import React from 'react';
import { FieldValues, useForm } from 'react-hook-form';

import { Select, SpinnerOverlay, SubmissionButtons } from '@components/common';

import { useManageSitesOptions } from '@hooks/useManageSitesOptions';

import styles from './LinkSiteForm.module.scss';

interface ILinkSiteFormProps {
	submitHandler: (siteDbId: string) => void;
	toggleLinkModal: () => void;
	closeModal: () => void;
}

const LinkSiteForm = ({
	submitHandler,
	toggleLinkModal,
}: ILinkSiteFormProps) => {
	const { unlinkedSites, isLoadingUnlinkForm } = useManageSitesOptions();

	const {
		handleSubmit,
		control,
		watch,
	} = useForm<FieldValues>({
		defaultValues: {
			site: null,
		},
	});

	const isDisabledSubmit = !watch('site');

	const sitesOptions = unlinkedSites.map((site: { id: string; siteId: string }) =>
		({ label: site.siteId, value: site.siteId, id: site.id }));

	const onSubmit = (values: FieldValues) => submitHandler(values.site.id);

	return (
		<div className={styles.linkSiteFormContainer}>
			{isLoadingUnlinkForm && <SpinnerOverlay />}
			<Select
				control={control}
				label='Site ID'
				name='site'
				options={sitesOptions}
				placeholder='Select site'
				required
			/>
			<SubmissionButtons
				className={styles.buttonsContainer}
				disabledPositive={isDisabledSubmit}
				negativeHandler={toggleLinkModal}
				positiveHandler={handleSubmit(onSubmit)}
				positiveLabel='Link'
			/>
		</div>
	);
};

export default LinkSiteForm;
